import * as React from "react";

import type { AppGalleryButtonProps } from "./AppGalleryButton.type";
import { useAppGalleryButton } from "./useAppGalleryButton";
import { useAppGalleryButtonStyles } from "./useAppGalleryButtonStyles.styles";

import { renderButton_unstable } from "@fluentui/react-components";
import type { ForwardRefComponent } from "@fluentui/react-components";

export const AppGalleryButton: ForwardRefComponent<AppGalleryButtonProps> =
  React.memo(
    React.forwardRef<HTMLButtonElement, AppGalleryButtonProps>((props, ref) => {
      const state = useAppGalleryButton(props, ref);
      useAppGalleryButtonStyles(state);
      return renderButton_unstable(state);
    }) as ForwardRefComponent<AppGalleryButtonProps>
  );
